import flute from '../../files/band/middleSchool/scales/02 Flute Region 20 Scales.pdf';
import oboe from '../../files/band/middleSchool/scales/03 Oboe Region 20 Scales.pdf';
import bassoon from '../../files/band/middleSchool/scales/04 Bassoon Region 20 Scales.pdf';
import clarinet from '../../files/band/middleSchool/scales/05 Clarinet Region 20 Scales.pdf';
import bassClarinet from '../../files/band/middleSchool/scales/06 Bass Clarinet Region 20 Scales.pdf';
import altoBariSax from '../../files/band/middleSchool/scales/07 Alto Bari Sax Region 20 Scales.pdf';
import tenorSaxophone from '../../files/band/middleSchool/scales/08 Tenor Saxophone Region 20 Scales.pdf';
import trumpet from '../../files/band/middleSchool/scales/09 Trumpet Region 20 Scales.pdf';
import frenchHorn from '../../files/band/middleSchool/scales/10 French Horn Region 20 Scales.pdf';
import tbnEuph from '../../files/band/middleSchool/scales/11 Tbn Euph Region 20 Scales.pdf';
import tuba from '../../files/band/middleSchool/scales/12 Tuba Region 20 Scales.pdf';

export const SCALES = {
  flute,
  oboe,
  bassoon,
  clarinet,
  bassClarinet,
  altoBariSax,
  tenorSaxophone,
  trumpet,
  frenchHorn,
  tbnEuph,
  tuba
};



// WEBPACK FOOTER //
// ./src/utils/constants/middleSchoolScales.js